var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2695_60616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.975 6.25H7.08333C6.86232 6.25 6.65036 6.3378 6.49408 6.49408C6.3378 6.65036 6.25 6.86232 6.25 7.08333V8.975",
    stroke: "#363A3A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91602 1.3916V2.08327C2.91602 2.41479 3.04771 2.73273 3.28213 2.96715C3.51655 3.20157 3.83449 3.33327 4.16602 3.33327C4.38703 3.33327 4.59899 3.42107 4.75527 3.57735C4.91155 3.73363 4.99935 3.94559 4.99935 4.1666C4.99935 4.62493 5.37435 4.99993 5.83268 4.99993C6.0537 4.99993 6.26566 4.91214 6.42194 4.75586C6.57822 4.59958 6.66602 4.38762 6.66602 4.1666C6.66602 3.70827 7.04102 3.33327 7.49935 3.33327H8.82018",
    stroke: "#363A3A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58268 9.14575V7.49992C4.58268 7.2789 4.49488 7.06694 4.3386 6.91066C4.18232 6.75438 3.97036 6.66659 3.74935 6.66659C3.52834 6.66659 3.31637 6.57879 3.16009 6.42251C3.00381 6.26623 2.91602 6.05427 2.91602 5.83325V5.41659C2.91602 5.19557 2.82822 4.98361 2.67194 4.82733C2.51566 4.67105 2.3037 4.58325 2.08268 4.58325H0.853516",
    stroke: "#363A3A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00065 9.16658C7.30184 9.16658 9.16732 7.30111 9.16732 4.99992C9.16732 2.69873 7.30184 0.833252 5.00065 0.833252C2.69946 0.833252 0.833984 2.69873 0.833984 4.99992C0.833984 7.30111 2.69946 9.16658 5.00065 9.16658Z",
    stroke: "#363A3A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2695_60616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.8f4ccb03b792c6a07b82a26f535757c9.svg";
export { ForwardRef as ReactComponent };